
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container } from 'react-bootstrap';
import headerImg from '../assets/images/pushtheboat_logo.svg';

export default class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }

    render() {
        return (
            <div className="modal-overview">
                <Container>
                    <br/>
                    <br/>
                    <br/>
                <Row>
                    <h1>Lets go for a walk!</h1>
                    <p>Next, you'll see a map with a generated route and markers showing the location of poems. You can click on these to see the poet and listen to the poem.</p>
                    <p>If you have location sharing turned on, we'll show you where you are as well, so you can be sure to see what the poet wants to show you....</p>
                </Row>
                <Row>
                    <span className="button-modal" onClick={() => this.props.closeModal()}>Let's Go...</span>
                </Row>
                </Container>

            </div>
        );
    }
}
